import apiClient from '@u/apiClient.js'

export default {
  fetchNewActivityLog({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/activity/new`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchActivityLogByDay({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/activity/by-day`, { params: payload.params })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeActivityLog({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/activity`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateActivityLog({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(`/activity/${payload.id}`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchActivities: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/activities`, {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
